import { IconProps } from "../types/Common";
import * as Iconos from "../icons";

export const Icon = (props: IconProps) => {
  const Icon = Iconos[props.name];
  return <Icon {...props} />;
};
